import React from "react";
import "./FashionSpotlight.css";

const FashionSpotlight = () => {
	return (
		<section className="stats-section">
			<div className="container">
				<div className="divonette-container">
					<h2 className="divonette-title">Moda za sve generacije</h2>
					<p className="divonette-text">
						Otkrijte raznovrsne kolekcije odjeće za djevojčice i dječake svih
						uzrasta. Nudimo kombinacije za svakodnevne aktivnosti, školske dane
						ili posebne prilike. U našem asortimanu možete pronaći sve od
						udobnih majica i hlača do elegantnih outfita za svečane događaje.
					</p>
				</div>
			</div>
		</section>
	);
};

export default FashionSpotlight;
